const VERSION_CODE = 'Version 1.0.0';

export default VERSION_CODE;